export const generalna_punomoc= {
    templateId: 87,
    category: 8,
    templateTitle: 'Opća (generalna) punomoć',
    templateDescription: `<p>Općom (generalnom) punomoći opunomoćitelj ovlašćuje oponumoćenika da može poduzimati pravne poslove navedene u punomoći.</p>`,
    description: `
    <h5>OPIS I SVRHA DOKUMENTA</h5>
    <p>Punomoć je ovlaštenje za zastupanje koje opunomoćitelj pravnim poslom daje opunomoćeniku.</p>
    <p>Opunomoćenik može biti i pravna osoba.</p>
    <p>Punomoć za zastupanje trgovačkog društva može dati samo zakonski zastupnik trgovačkog društva. </p>
    <p>Iako, teoretski, u nekim slučajevima punomoć može biti dana i usmeno, svakako se predlaže pisani oblik punomoći.</p> 
    <p>U tom smislu svakako se treba pridržavati odredbe Zakona o obveznim odnosima prema kojoj se oblik propisan zakonom za neki ugovor ili koji drugi pravni posao odnosi i na punomoć za sklapanje toga ugovora, odnosno za poduzimanje toga posla.</p> 
    <p><strong>Važno ograničenje kod opće punomoći je da opunomoćenik ne može bez posebnog ovlaštenja za svaki pojedini slučaj preuzeti mjeničnu obvezu, sklopiti ugovor o jamstvu, o nagodbi, a ni odreći se nekog prava bez naknade.</strong></p> 
    <p>Punomoć se može vremenski ograničiti tako da vrijedi samo na određeno vrijeme.</p>
    <p>Opunomoćitelj može po svojoj volji suziti ili opozvati punomoć, čak iako se odrekao toga prava.</p> 
    <p>Valja skrenuti pozornost na odredbu Zakona o zemljišnim knjigama prema kojoj je uknjižba dopuštena na temelju privatne isprave potpisane po oponumoćeniku, ukoliko je dana posebna (specijalna) ponomoć za potpis navedene ispravu ili ukoliko je dana opća punomoć ili generična punomoć (za određenu vrstu poslova) koja nije starija od jedne godine. Osim toga, nužno je da istinitost potpisa na takvoj punomoći bude ovjerovljena.</p>
    <p>Kod eventualnog opoziva punomoći predlaže se da o opozivu budu informirani svi koji bi eventualno mogli sklapati pravne poslove s oponumoćenikom na temelju opozvane punomoći odnosno svi koji bi eventualno mogli provoditi tako sklopljene pravne poslove (zemljišnoknjižni sud za nekretnine, policijska uprava za registrirana vozila i sl.)</p>
    <p>To iz razloga što, opoziv punomoći te njezino sužavanje nema učinak prema trećoj osobi koja je sklopila ugovor s opunomoćenikom ili obavila drugi pravni posao, a nije znala niti je morala znati da je punomoć opozvana, odnosno sužena.</p>
    <h5>PRAVNA OSNOVA</h5>
    <p>Zakon o obveznim odnosima, Zakon o zemljišnjim knjigama.</p>
    `,
    sides: [
      {
        prefix: "",
        signature: 'Za Opunomoćitelja',
        inputs: [{
          type: "input",
          required: true,
          placeholder: "Posl. subj./Ime i prezime",
        },
        {
          type: "input",
          required: true,
          placeholder: "Ulica i kućni broj",
        },
        {
          type: "input",
          required: true,
          placeholder: "Mjesto i poštanski broj",
        },
        {
          type: "input",
          required: true,
          placeholder: "OIB",
        },
        {
          type: "input",
          placeholder: "Zastupa",
          inSignature: true,
        },
        {
          type: "input",
          placeholder: "Funkcija",
          inSignature: true,
        }
      ],
      suffix: '(Opunomoćitelj),',
      }
    ],
  

    headline: "daje sljedeću",
    title: 'PUNOMOĆ',
    noArticleNumbers: true,
    noArticleTitle: true,

    articles: [

      {
        title: '',
        mandatory: false,
        dummy: true,
        exampleContent: true,
        statements: [
            {
                type: 'text',
                required: true,
                mandatory: true,
                editable: true,
                content: 'kojom, opunomoćuje diplomiranog pravnika ____________________, iz__________________,__________________, OIB:___________________, zaposlenog kod Opunomoćitelja kao poslodavca, da ga zastupa u građanskom, parničnom, izvanparničnom, ovršnom, zemljišnoknjižnom postupku, kaznenom postupku, u postupku pred tijelima državne uprave te da u tom smislu može povući tužbu, odreći se od tužbenog zahtjeva, priznati tužbeni zahtjev, sklopiti nagodbu, odreći se ili odustati od pravnog lijeka, prenijeti punomoć na druge osobe i podnijeti prijedlog za obnovu postupka. ',
                value: '',
            },
        ],
        value: '',
    },
        // {
        //     title: "",
        //     mandatory: false,
        //     exampleContent: true,
        //     statements: [
        //       {
        //         type: "input",
        //         mandatory: true,
        //         parts: [
        //           { type: "text", content: "kojom, opunomoćuje diplomiranog pravnika zaposlenog kod Poslodavca,", help: 'U slučaju da punomoć izdajete generelnu punomoć da druge vrste poslova, ovu točku možete obrisati te izraditi punomoć prema ovom primjeru.' },
        //           { type: 'input', value: '', required: true, placeholder: "Posl. subj./Ime i prezime" },
        //           { type: "text", content: "," },
        //           { type: 'text', content: 'iz',},
        //           { type: 'input', value: '', required: true, placeholder: "Mjesto"   },
        //           { type: 'text', content: ',' },
        //           { type: 'input', value: '', required: true, placeholder: "Ulica i kućni broj" },
        //           { type: "text", content: "," },
        //           { type: 'text', content: 'OIB:' },
        //           { type: "input",  required: true,},
        //           { type: 'text', content: ', (Opunomoćenik)' },
        //           { type: "text", content: "da ga zastupa u građanskom, parničnom, izvanparničnom, ovršnom, zemljišnoknjižnom postupku, kaznenom postupku, u postupku pred tijelima državne uprave te da u tom smislu može povući tužbu, odreći se od tužbenog zahtjeva, priznati tužbeni zahtjev, sklopiti nagodbu, odreći se ili odustati od pravnog lijeka, prenijeti punomoć na druge osobe i podnijeti prijedlog za obnovu postupka." }, 

        //         ],
        //       }
        //     ]
        //   },

          {
            title: "",
            mandatory: true,
            dummy: true,
            statements: [
              {
                type: "choice",
                mandatory: true,
                editable: false,
                choices: [
                    {
                        parts: [
                          { type: "text", content: "Ova punomoć daje se na neodređeno vrijeme i vrijedi do opoziva." },
                        ]
                      },
                {
                    parts: [

                        { type: "text", content: "Ova punomoć daje se na određeno vrijeme i vrijedi do" },
                        { type: "input", value: "", required: true,  help: 'Upišite do kada vrijedi punomoć, npr. do 15.11.2020., ili dvije godine od dana davanja punomoći.' },

                    ]
                  },
                ],
              }
            ]
          },
          {
            mandatory: true,
            static: true,
            type: 2, // date and place
            statements: [
                {
                    type: 'input',
                    mandatory: true,
                    parts: [
                        {
                            type: 'text',
                            content: 'U'
                        },
                        {
                            type: 'input',
                            value: '',
                            placeholder: "Upišite mjesto.",
                            required: true
                        },
                        {
                            type: 'text',
                            content: ', dana'
                        },
                        {
                            type: 'date',
                            value: new Date(),
                            required: true
                        },
                        {
                            type: 'text',
                            content: 'godine.',
                        }
                    ]
                },
            ]
        },
                {
                    mandatory: true,
                    static: true,
                    type: 3,  // signatures
                    statements: [],
                },
            ],
};










// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/87_generalna_punomoc.ts